import { GeolocationData } from './geolocation';

export enum DeviceTypeIdEnum {
  STATIONARY_KIOSK = 1,
  MOBILE_KIOSK = 2,
  TABLET_KIOSK = 3,
  PHONE = 4,
  TABLET = 5,
}

export enum DeviceTypeEnum {
  STATIONARY_KIOSK = 'STATIONARY_KIOSK',
  MOBILE_KIOSK = 'MOBILE_KIOSK',
  TABLET_KIOSK = 'TABLET_KIOSK',
  PHONE = 'PHONE',
  TABLET = 'TABLET',
}

export type DeviceData = {
  deviceId: string;
  deviceName: string;
  deviceType: DeviceTypeEnum;
  geolocation: GeolocationData;
  ipAddress?: string;
  date: string;
  hardwareLevel?: number;
};
